<template>
    <a-modal v-model="visible" title="行程结束&评分" @ok="handleOk" @cancel="handleClose" :confirmLoading="confirmLoading"
        :maskClosable="false">
        <a-form-model ref="ruleForm" :model="form" :rules="rules">
            <a-form-model-item label="行程状态" prop="is_over">
                <a-radio-group v-model="form.is_over">
                    <a-radio value="0">
                        确认中
                    </a-radio>
                    <a-radio value="1">
                        出行中
                    </a-radio>
                    <a-radio value="2">
                        已结束
                    </a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="请选择满意度" prop="satisfaction_level">
                <a-select v-model="form.satisfaction_level" placeholder="请选择满意度">
                    <a-select-option value="1">
                        非常满意
                    </a-select-option>
                    <a-select-option value="2">
                        满意
                    </a-select-option>
                    <a-select-option value="3">
                        一般
                    </a-select-option>
                    <a-select-option value="4">
                        不满意
                    </a-select-option>
                    <a-select-option value="5">
                        未回复
                    </a-select-option>
                    <a-select-option value="6">
                        会员本人不出行
                    </a-select-option>
                    <a-select-option value="7">
                        退会
                    </a-select-option>
                    <a-select-option value="8">
                        行程取消
                    </a-select-option>
                    <a-select-option value="9">
                        客人删督导微信
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="满意度备注" prop="satisfaction_remark">
                <a-input v-model="form.satisfaction_remark" placeholder="满意度备注"></a-input>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: {
                trip_id: "",
                is_over: "",
                satisfaction_level: undefined,
                satisfaction_remark: ''
            },
            submitLoading: false,
            rules: {
                is_over: [
                    {
                        required: true,
                        message: "请选择行程状态",
                        trigger: "change",
                    },
                ],
                satisfaction_level: [
                    {
                        required: false,
                        message: "请选择满意度",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    methods: {
        init(trip_id) {
            this.form.trip_id = trip_id;
            this.visible = true;
            if (trip_id) {
                this.$http({
                    url: '/admin/trip/info',
                    method: 'post',
                    data: {
                        id: trip_id
                    }
                }).then(res => {
                    this.form = {
                        trip_id: res.data.trip_id,
                        is_over: res.data.is_over,
                        satisfaction_level: res.data.satisfaction_level || undefined,
                        satisfaction_remark: res.data.satisfaction_remark,
                    }
                })
            }
        },
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$http({
                        url: "/admin/trip/tripover",
                        method: "post",
                        data: this.form,
                    })
                        .then(() => {
                            this.$message.success("操作成功");
                            this.handleClose();
                            this.$emit("ok");
                        })
                        .finally(() => (this.confirmLoading = false));
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleClose() {
            this.$refs.ruleForm.resetFields();
            this.visible = false;
        },
    },
};
</script>

<style></style>